import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { InfoFullIcon } from 'src/components/shared/ui/Icons'
import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import InputField from 'src/components/shared/ui/form/fields/InputField'
import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import { useLexnetStatusContext } from 'src/contexts/LexnetStatusContext'
import { FormField } from 'src/enums/Form'
import { theme } from 'src/providers/ThemeProvider'
import { remitenteStyles as styles } from './RemitenteStyles'

type Props = {
  componentId: string
}

function Remitente({ componentId }: Props): JSX.Element {
  const [isConnected, setIsConnected] = useState(false)
  const { t } = useTranslation()
  const { setFieldValue } = useFormikContext<EscritosFormValues>()
  const { connected, lexnetUserText, lexnetUser } = useLexnetStatusContext()

  useEffect(() => {
    setIsConnected(connected)
  }, [connected])

  // useEffect(() => {
  //   if (lexnetUserText() && !remitenteValue) {
  //     setFieldValue(FormField.REMITENTE_TITULAR, lexnetUserText())
  //   }
  // }, [lexnetUserText, remitenteValue, setFieldValue])

  useEffect(() => {
    setFieldValue(FormField.REMITENTE_TITULAR, lexnetUserText())
  }, [lexnetUser, lexnetUserText, setFieldValue])

  return (
    <FieldsetGroup legend={t('form.legend.remitente')} customClass="remitente">
      {isConnected && (
        <Box sx={{ padding: '8px 0' }}>
          <input type="hidden" value={componentId} />
          <InputField
            id={FormField.REMITENTE_TITULAR}
            label={t('form.field.titular')}
            required
            readOnly
          />
        </Box>
      )}
      {!isConnected && (
        <Box sx={styles.noConnected} display="flex" alignItems="center">
          <InfoFullIcon sx={styles.noConnectedInfoIcon} htmlColor={theme.colors.byzantineBlue200} />
          <span id={FormField.REMITENTE_TITULAR}>{t('alert.not_connected')}</span>
        </Box>
      )}
    </FieldsetGroup>
  )
}

export default Remitente
